export interface GraphqlErrorExtensions {
	code?: string;
	openTelemetryTraceId?: string;
	statusCode?: number;
}

// the logged-in user has no e-mail address, which the app relies on
export const USER_WITHOUT_EMAIL_ERROR_CODE = 'USER_WITHOUT_EMAIL';
